// Exportamos un objeto que usa un placeholder temporal '__'__PATH__'__'
// que será reemplazado por la ruta real en los archivos de entorno.

const ENDPOINTS_BASE = {
  auth: '__PATH__' + 'authenticate/',
  empresa: '__PATH__' + 'empresa/',
  area: '__PATH__' + 'area/',
  tipoArea: '__PATH__' + 'tipoArea/',
  sede: '__PATH__' + 'sede/',
  cargo: '__PATH__' + 'cargo/',
  CargoActualService: '__PATH__' + 'cargoActual/',
  scm: '__PATH__' + 'casomedico/',
  pcl: '__PATH__' + 'pcl/',
  EmpresaService: '__PATH__' + 'empresa/',
  ContextoOrganizacionService: '__PATH__' + 'contextoOrganizacion/',
  CargoService: '__PATH__' + 'cargo/',
  CompetenciaService: '__PATH__' + 'competencia/',
  RecursoService: '__PATH__' + 'recurso/',
  PermisoService: '__PATH__' + 'permiso/',
  UsuarioService: '__PATH__' + 'usuario/',
  EmpleadoService: '__PATH__' + 'empleado/',
  EmpleadoBasicService: '__PATH__' + 'empleadobasic/',
  EmpleadoJwtService: '__PATH__' + 'empleadoJwt/',
  EvaluacionDesempenoService: '__PATH__' + 'evaluacionDesempeno/',
  PerfilService: '__PATH__' + 'perfil/',
  ConfiguracionJornadaService: '__PATH__' + 'configuracionJornada/',
  HorasExtraService: '__PATH__' + 'horasExtra/',
  HhtService: '__PATH__' + 'hht/',
  HhtIliService: '__PATH__' + 'hhtIli',
  emp_perfil: '__PATH__' + 'perfil/',
  anexoSCM: '__PATH__' + 'anexscm/',
  departamento: '__PATH__' + 'departamento/',
  ciudad: '__PATH__' + 'ciudad/',
  SistemaGestionService: '__PATH__' + 'sistemaGestion/',
  sge_sistemagestion: '__PATH__' + 'sistemaGestion/',
  EvaluacionService: '__PATH__' + 'evaluacion/',
  sge_respuesta: '__PATH__' + 'respuesta/',
  RespuestaService: '__PATH__' + 'respuesta/',
  sge_reporte: '__PATH__' + 'reportesSGE/',
  ReporteSGEService: '__PATH__' + 'reportesSGE/',
  ElementoService: '__PATH__' + 'elementoSGE',
  com_ciiu: '__PATH__' + 'ciiu/',
  com_arl: '__PATH__' + 'arl/',
  com_afp: '__PATH__' + 'afp/',
  com_eps: '__PATH__' + 'eps/',
  com_juntas: '__PATH__' + 'JuntaRegional/',
  com_prepagadas: '__PATH__' + 'prepagadas/',
  com_provsalud: '__PATH__' + 'provsalud/',
  com_ccf: '__PATH__' + 'ccf/',
  com_pais: '__PATH__' + 'pais/',
  com_cie: '__PATH__' + 'cie/',
  com_departamento: '__PATH__' + 'departamento/',
  CiudadService: '__PATH__' + 'ciudad/',
  com_tipoIdentificacion: '__PATH__' + 'enums/tipoIdentificacion/',
  com_tipoVinculacion: '__PATH__' + 'enums/tipoVinculacion/',
  com_tipoSede: '__PATH__' + 'enums/tipoSede/',
  DesviacionService: '__PATH__' + 'desviacion/',
  DesviacionAliadosService: '__PATH__' + 'desviacionAliados/',
  ReporteAtService: '__PATH__' + 'reporteatview/',
  AnalisisDesviacionService: '__PATH__' + 'analisisDesviacion/',
  SistemaCausaRaizService: '__PATH__' + 'sistemaCausaRaiz/',
  SistemaCausaInmediataService: '__PATH__' + 'sistemaCausaInmediata/',
  TareaService: '__PATH__' + 'tarea/',
  TipoAreaService: '__PATH__' + 'tipoArea/',
  AreaService: '__PATH__' + 'area/',
  ListaInspeccionService: '__PATH__' + 'listaInspeccion/',
  ViewListaInspeccionService: '__PATH__' + 'vlistainpperfil/',
  ViewInspeccionService: '__PATH__' + 'vinpperfil/',
  ProgramacionService: '__PATH__' + 'programacion/',
  InspeccionService: '__PATH__' + 'inspeccion/',
  ViewInspeccionCtr: '__PATH__' + 'viewInspeccionesCtr/',
  cumplimientoService: '__PATH__' + 'cumplimiento/',
  ViewResumenAliadosService: '__PATH__' + 'viewResumenAliados/',
  TipoHallazgoService: '__PATH__' + 'tipoHallazgo/',
  SerieService: '__PATH__' + 'serieEvento/',
  SistemaNivelRiesgoService: '__PATH__' + 'sistemaNivelRiesgo/',
  TarjetaService: '__PATH__' + 'tarjeta/',
  ObservacionService: '__PATH__' + 'observacion/',
  ReporteService: '__PATH__' + 'reporte/',
  DirectorioService: '__PATH__' + 'directorio/',
  ReporteAusentismoService: '__PATH__' + 'reporteAusentismo/',
  CausaAusentismoService: '__PATH__' + 'causaAusentismo/',
  IndicadorAusentismoService: '__PATH__' + 'indicadorAusentismo/',
  IndicadorEmpresaService: '__PATH__' + 'indicadorEmpresa/',
  IndicadorSgeService: '__PATH__' + 'indicadorSge/',
  IndicadorService: '__PATH__' + 'indicador/',
  TableroService: '__PATH__' + 'tablero/',
  ModeloGrafica: '__PATH__',
  CaracterizacionViewService: '__PATH__' + 'indcar/',
  Plantas: '__PATH__' + 'plantas/',
  ViewscmcoService: '__PATH__' + 'indscmco/',
  ViewscmgeService: '__PATH__' + 'indscmge/',
  ViewHHtMetasService: '__PATH__' + 'viewhhtmeta/',
  metaService: '__PATH__' + 'meta/',
  MatrizPeligrosLogService: '__PATH__' + 'matrizPlog/',
  MatrizPeligrosService: '__PATH__' + 'matrizP/',
  ViewMatrizPeligrosService: '__PATH__' + 'vmatrizP/',
  ViewMatrizPeligrosLogService: '__PATH__' + 'vmatrizPLog/',
  TipoPeligroService: '__PATH__' + 'tipoPeligro/',
  PeligroService: '__PATH__' + 'peligro/',
  FuenteService: '__PATH__' + 'fuente/',
  EfectoService: '__PATH__' + 'efecto/',
  TipoControlService: '__PATH__' + 'tipoControl/',
  ControlService: '__PATH__' + 'control/',
  IpecrService: '__PATH__' + 'ipecr/',
  PeligroIpecrService: '__PATH__' + 'peligroIpecr/',
  ParticipanteIpecrService: '__PATH__' + 'participanteIpecr/',
  AreaMatrizService: '__PATH__' + 'areaMatriz/',
  SubprocesoMatrizService: '__PATH__' + 'subProcesoMatriz/',
  ProcesoMatrizService: '__PATH__' + 'procesoMatriz/',
  ConfiguracionGeneralService: '__PATH__' + 'configuracion/',
  SistemaCausaAdministrativaService: '__PATH__' + 'sistemaCausaAdministrativa/',
  ActaService: '__PATH__' + 'acta/',
  ContactoService: '__PATH__' + 'contacto/',
  ViewscmInformeService: '__PATH__' + 'viewinfoscm/',
  ViewSaludLaboralService: '__PATH__' + 'viewsl/',
  ViewSignosVitalesService: '__PATH__' + 'viewSV/',
  ViewProgramacionSignosVitalesService: '__PATH__' + 'viewProgSV/',
  ViewTareaSignosVitalesService: '__PATH__' + 'viewTareaSV/',
  ViewAprobadoresSVService: '__PATH__' + 'viewAprobadorSV/',
  ConstanteFrecuenciaService: '__PATH__' + 'frecuencia/',
  ManualService: '__PATH__' + 'manual/',
  tareaService: '__PATH__',
  firmaservice: '__PATH__' + 'firm/',
  RegistroFaltasAliadosService: '__PATH__' + 'registroFaltasAliados/',
  RequisitoDocumentalService: '__PATH__' + 'requisitos',
  CategoriaEppService: '__PATH__' + 'categoriaepp/',
  ElementoEppService: '__PATH__' + 'elementoepp/',
  FileseppService: '__PATH__' + 'filesepp/',
  FichaTecnicaEppService: '__PATH__' + 'fichatecnicaepp/',
  AsignacionEppService: '__PATH__' + 'asignacionepp/',
  FrecuenciaEppService: '__PATH__' + 'frecuenciaepp/',
  InventarioService: '__PATH__' + 'inventario/',
  StockService: '__PATH__' + 'stock/',
  UnidadMedidaService: '__PATH__' + 'unidadmedida/',
  SolicitudEppService: '__PATH__' + 'solicitud-epp/',
  DetalleSolicitudEppService: '__PATH__' + 'detalle-solicitud-epp/',
  EstadoSolicitudService: '__PATH__' + 'estado-solicitud/',
  EstadoDetalleSolicitudService: '__PATH__' + 'estado-detalle-solicitud/',
  HistorialSolicitudEppService: '__PATH__' + 'historial-solicitud-epp/',
  LogInventarioService: '__PATH__' + 'log-inventario/',
  UsuarioPermitidoService: '__PATH__' + 'usuariopermitido/',
  SolicitudTransferenciaService: '__PATH__' + 'solicitud-transferencia-epp/',
  DetalleTransferenciaEppService: '__PATH__' + 'detalle-transferencia-epp/',
  ActaEntregaEppService: '__PATH__' + 'acta-entrega-epp/',
  DetalleActaEntregaService: '__PATH__' + 'detalle-acta-entrega/',
  EnvioCorreoService: '__PATH__' + 'envio-correo/',
  NotificacionEntregaService: '__PATH__' + 'notificacion-entrega/',
  CostoEppService: '__PATH__' + 'costoepp/',
  ProveedorService: '__PATH__' + 'proveedor/',
  CotizacionService: '__PATH__' + 'cotizacion/',
  CotizacionDetalleService: '__PATH__' + 'detalle-cotizacion/',
  SolicitudCotizacionService: '__PATH__' + 'solicitud-cotizacion/',
  DetalleSolicitudCotizacionService:
    '__PATH__' + 'detalle-solicitud-cotizacion/',
  SolicitudDetalleService: '__PATH__' + 'solicitud-detalle/',
  OrdenCompraService: '__PATH__' + 'orden-compra/',
  OrdenDetalleService: '__PATH__' + 'orden-detalle/',
  EntregaService: '__PATH__' + 'entrega/',
  DetalleEntregaService: '__PATH__' + 'detalle-entrega/',
  InventarioProveedorService: '__PATH__' + 'inventario-proveedor/',
  PrecioProveedorService: '__PATH__' + 'precio-proveedor/',
  PrecioVentaService: '__PATH__' + 'precio-venta/',
  PromocionPrecioService: '__PATH__' + 'promocion-precio/',
  NotificacionProveedorService: '__PATH__' + 'notificacion-proveedor/',
  ProcesamientoCargaService: '__PATH__' + 'procesamiento-carga/',

  sEmpresaProveedorService: '__PATH__' + 'empresa-proveedor/',
  CategoriaEppProveedorService: '__PATH__' + 'categoria-epp-proveedor/',
  ProveedorEppService: '__PATH__' + 'proveedor-epp/',
  ProveedorEppFichaService: '__PATH__' + 'proveedor-epp-ficha/',
  KardexProveedorService: '__PATH__' + 'kardex/',
  StockProveedorService: '__PATH__' + 'stock/',
  CargueMasivoService: '__PATH__' + 'cargue-masivo/',
  RemisionEntregaService: '__PATH__' + 'remision-entrega/',
  RemisionDetalleService: '__PATH__' + 'remision-detalle/',
  IntegracionInventarioService: '__PATH__' + 'integracion-inventario/',
  MarketplaceService: '__PATH__' + 'marketplace/',
  riesgos: '__PATH__' + 'riesgos/',

  ProgramaGestionRiesgoService: '__PATH__' + 'programaGestionRiesgo/empresa',
};
export default ENDPOINTS_BASE;
